// extracted by mini-css-extract-plugin
module.exports = {"open":"styles_open__HK09p","partial":"styles_partial__okDwJ","closed":"styles_closed__ppxSW"};